module.exports = {
      id: "star-usage",
      viewBox: "0 0 36.688 45.344",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#star",
      toString: function () {
        return this.url;
      }
    }